<template> 
    <v-card flat>
        <v-card-title class="subheading" style="height:50px">
            <strong>Filters</strong>
            <v-spacer/>
            <IconAdd @clicked="newReportClicked" />
            <IconClose @clicked="closeDialog" />
            
        </v-card-title>
        <hr>
        <v-card-text>
          <template v-for="subscription in subscriptions">
              <v-layout row wrap style="margin-top:5px;margin-bottom:5px">
            <v-hover>
            <v-flex style="padding:5px" xs10 slot-scope="{ hover }" :class="`${hover? 'indigo white--text': 'white black--text'}`">
              
                        <v-icon @click="showMore(subscription)" small :class="`${hover? 'pink--text': 'grey--text'}`" >fas fa-angle-down</v-icon>
              &nbsp;
                        <span 
                        class="filterName"
                         style="cursor:pointer" @click="applyFilters(subscription)" >{{subscription.name}}</span>
            </v-flex>
                </v-hover>
            <v-flex xs2 class="text-xs-right">
                 <IconPlay   v-if= "!subscription.processing" @clicked="generateReport(subscription)" /> 
                <v-progress-circular
                :width="2"
                color="red"
                indeterminate
                small
                size="15"
                v-if= "subscription.processing" 
                >
                </v-progress-circular>
                &nbsp;
            </v-flex>
            <v-flex xs11 v-if="subscription.showDetails">
                <v-card style="margin-left:25px;margin-right:5px;" flat >
                   
                    <v-card-text>
                <v-layout row wrap>
                    <v-flex xs6 pa-2>
                    <span small class="user2  caption">Owner : {{subscription.user}}</span>
                    </v-flex>
                    
                    <v-flex xs6 pa-2>
                    <span small  class="dt  caption">{{moment(subscription.next_date).fromNow()}}</span><br/>
                    </v-flex>
                    <v-flex xs6 pa-2>
                    <template v-for="email in subscription.email_to">
                        <span small dense class="email ">{{email}}</span> <br/>
                    </template>
                    </v-flex>
                    
                    <v-flex xs6 pa-2>
                    <span small dense class="download">
                        Download &nbsp;
                        <v-icon style="zoom:80%;color:#EF2035" small @click="getLink(subscription)">fa fa-download</v-icon>
                    </span>
                    </v-flex>
                </v-layout>
                </v-card-text>
                </v-card>
            </v-flex>
            </v-layout>

            <v-divider/>
          </template>
        </v-card-text>
    </v-card>
</template>
<script>
import IconAdd from '@/components/Icons/IconAdd'
import IconClose from '@/components/Icons/IconClose'
import IconPlay from '@/components/Icons/IconPlay'

import ReportSubscriptionModel from '@/api/service/ReportSubscriptionService'
import moment from 'moment'
export default {
    components:{
        IconAdd,IconClose,IconPlay
    },
    props: [
        
    ],
    data() {
        return {
            selected: [],
            subscriptions: [],
            class1:"blue white--text",
            class2:"white black--text"
        }
    },
    created: function() {
        this.getFilters()
    },
    methods: {
        moment,
        getFilters() {
           var $opx = {}
            if(this.$store.getters.userInfo.super_user!=1) {
                $opx = {"created_by":this.$store.getters.userInfo.id,"active":1}
            }
            ReportSubscriptionModel.findAll($opx)
                .then(response => {
                    this.subscriptions=response
                }).catch(error => {
                    console.log(error)
                }); 
        },
        showMore($sub) {
            if($sub.showDetails) {
                $sub.showDetails = !$sub.showDetails
            } else {
            $sub.showDetails=true
            }
            this.$forceUpdate()
           // alert('i am here')
            
        },
        applyFilters($sub) {
            this.$emit('applyFilters',$sub)
        },
        closeDialog() {
            this.$emit('closeDialog')
        },
        newReportClicked() {
            this.$emit('newReportClicked')
        },
        getLink($item) {
           if($item.export) {
               //alert(JSON.stringify($item.export))
           var $fileType = $item.export.options.file_type
        
            switch($fileType) {
                case 'Pdf':
                                return '/files/'+$item.name.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/ ]/gi, '')+'-'+$item.report_log_id+".pdf"; break;
                case 'Excel':   return '/files/'+$item.name.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/ ]/gi, '')+'-'+$item.report_log_id+".xlsx"; break;
            }
           }
                
        },
        generateReport(item,index) {        
            item.processing = 1    
            //this.processing.push({"id":item.id,"index":index})
                ReportSubscriptionModel.submitReport(item.id)
                .then(response => {
                    item.processing = 0
                    item.report_log_id = response.data.data.report_log_id
                }).catch(error => {

            }); 
        },
    }
}
</script>
<style>
.class1 {
  color:green
}
.filterName {
font-family: Roboto;
font-style: normal;
font-weight: normal;
font-size: 14px;
line-height: 14px;
letter-spacing: 0.03em;
}
.user2 {
    background:#DBF3FF;
    padding:1px;
    border-radius:10px;
    color:#00A8FF;
    padding:5px;
    line-height:20px;
    height:30px;
}

.email {
    background:#ffe9c4;
    padding:1px;
    border-radius:10px;
    color:#FFA000;
    padding:5px;
}

.dt {
    background:#EDDFFF;
    padding:1px;
    border-radius:10px;
    color:#7200FF;
    padding:5px;
}

.download {
    background:#facacf;
    padding:1px;
    border-radius:10px;
    color:#EF2035;
    padding:5px;
}
.class2 {

}
</style>